export default __webpack_public_path__ + "static/media/inbox-cleanup.b6f8282d.svg";